import GridTable from '@/components/table/GridTable'
import { HStack } from '@musinsa/mwms-ds'
import { HistoryDownloadLogItem } from '@/services/history/history.types'
import { PAGE_SIZE_ON_HISTORY } from '@/services/history/useHistoryQuries'
import Excel from '@/utils/Excel'
import { COLUMN_WIDTH } from '@/utils/grid/grid'
import { ColDef } from 'ag-grid-community'

interface DownloadLogTableProps {
  data: HistoryDownloadLogItem[]
  isLoading?: boolean
}
export const DownloadLogTable = ({ data, isLoading }: DownloadLogTableProps) => {
  const columnDefs: ColDef<HistoryDownloadLogItem>[] = [
    { field: 'email', headerName: '이메일', width: COLUMN_WIDTH.tinyText },
    { field: 'evtDate', headerName: '날짜', cellDataType: 'dateNday', width: COLUMN_WIDTH.date },
    { field: 'evtTime', headerName: '시간', cellDataType: 'time', width: COLUMN_WIDTH.time },
    { field: 'menuCd', headerName: '메뉴코드', width: COLUMN_WIDTH.status },
    { field: 'actTyp', headerName: '활동유형', width: COLUMN_WIDTH.status },
    { field: 'remark', headerName: '사유', width: COLUMN_WIDTH.tinyText },
  ]

  return (
    <HStack full gap={16}>
      <GridTable<HistoryDownloadLogItem>
        gridKey="HS03_HEAD"
        rowData={data}
        isLoading={isLoading}
        pagination
        countPerPage={PAGE_SIZE_ON_HISTORY}
        paginationPageSize={PAGE_SIZE_ON_HISTORY}
        columnDefs={columnDefs}
        totalCount={data.length}
        useColumnNo
        useColumnFilter
        exportType="private"
        onExportData={() => Excel.download<HistoryDownloadLogItem>({ columnDefs, rowData: data })}
      />
    </HStack>
  )
}
